import { Helmet } from 'react-helmet-async';
import { Card } from 'components';
import useUpsaleChangeAmount from './useUpsaleChangeAmount';
import { TwButton } from 'components/TwButton/TwButton';
import H1 from 'components/H/H1';
import Sliders from 'components/Sliders/Sliders';
import OfferTable from 'components/OfferTable/OfferTable';
import { useTranslation } from 'react-i18next';

export default function UpsaleChangeAmount() {
  const { t } = useTranslation();
  const {
    upsaleConstraintsData,
    amount,
    onAmountChange,
    handleConfirm,
    isLoading,
    isPending,
    offer,
  } = useUpsaleChangeAmount();

  return (
    <>
      <Helmet>
        <title>{t('upsale:html_title')}</title>
      </Helmet>

      <H1 dataTest="upsaleChangeAmount-title" className="px-6 lg:px-0">
        {t('upsale:title')}
      </H1>

      <div className="flex flex-col gap-6">
        <Card
          className="flex flex-col gap-6 pt-0 lg:pt-6 p-0"
          dataTest="upsaleChangeAmount-card"
        >
          <div className="border-t border-b lg:border-none p-6 lg:pt-0">
            {upsaleConstraintsData && (
              <Sliders
                amount={amount}
                constraints={upsaleConstraintsData}
                onAmountChange={onAmountChange}
                dataTest="upsaleChangeAmount-sliders"
              />
            )}
          </div>

          <div className="w-full pb-4 p-6 pt-0">
            <OfferTable
              totalPrincipal={offer?.totalPrincipal}
              totalRepayableAmount={offer?.totalRepayableAmount}
              extensionFees={offer?.extensionFees[30]}
              interestRate={offer?.interestRate}
              assignedInterest={offer?.assignedInterest}
              firstPaymentDate={offer?.firstPaymentDate}
              futureExtensionFees={offer?.futureExtensionFees?.[0]?.fee}
              loading={isLoading}
            />
          </div>
        </Card>
        <div className="px-6">
          <TwButton
            data-test="new-offer-btn"
            pending={isPending}
            disabled={isPending || isLoading}
            onClick={handleConfirm}
          >
            {t('upsale:button_change_amount')}
          </TwButton>
        </div>
      </div>
    </>
  );
}
